export {
  default as swimplyLogo,
  ReactComponent as SwimplyLogo,
} from '@assets/swimplyLogo.svg'    
